import { render } from "./friends.vue?vue&type=template&id=aedaf7e6&scoped=true"
import script from "./friends.vue?vue&type=script&lang=js"
export * from "./friends.vue?vue&type=script&lang=js"

import "./friends.vue?vue&type=style&index=0&id=aedaf7e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aedaf7e6"

export default script